import i18n from 'es2015-i18n-tag';
import { Field, FormikBag, FormikProps, withFormik } from 'formik';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { compose } from 'ramda';
import Input from '../../../../common/ui-components/input/input.component';
import { SportTeamCreateModel } from '../../models/sport-team-create-model';
import { getBusinessTemplates } from '../../team-service';
import CreateTeam, { CreateTeamFormValue, formSchema } from './create-team.component';

export interface CreateBusinessTeamProps {
    createTeam: (model: SportTeamCreateModel) => Promise<void>;
}

const onCreate = (
    formValue: CreateTeamFormValue,
    actions: FormikBag<CreateBusinessTeamProps & RouteComponentProps, CreateTeamFormValue>
) => {
    const { name, sport, league, survey } = formValue;
    actions.props
        .createTeam({
            name,
            sport,
            league,
            templateKey: survey.templateKey,
            hasSixPossibleAnswers: survey.hasSixPossibleAnswers,
            isPrinorQuest: survey.isPrinorQuest
        })
        .then(() => {
            actions.props.history.goBack();
        })
        .finally(() => {
            actions.setSubmitting(false);
        });
};

const CreateBusinessTeam = (props: FormikProps<CreateTeamFormValue>) => {
    const [templates, setTemplates] = useState([]);

    useEffect(() => {
        getBusinessTemplates().then(res => {
            props.setFieldValue('survey', res[0]);
            setTemplates(res);
        });
    }, []);

    return (
        <CreateTeam {...props} templates={templates}>
            <Field
                component={Input}
                title={i18n`Firma`}
                name="sport"
                className="create-team__form-field"
                required
            />
            <Field
                component={Input}
                title={i18n`Standort`}
                name="league"
                className="create-team__form-field"
                required
            />
        </CreateTeam>
    );
};

const enhance = compose(
    withRouter,
    withFormik({
        displayName: 'CreateTeam',
        validationSchema: formSchema,
        handleSubmit: onCreate,
        mapPropsToValues: () => ({
            name: '',
            sport: '',
            league: '',
            survey: null
        })
    })
);

export default enhance(CreateBusinessTeam);
